import { useContext } from "react";
import { AppContext } from "../App";
import { MdMenu } from "react-icons/md";
import logo_icon from '../assets/logo_icon.png';

export default function TopBar(props) {
  const appContext = useContext(AppContext);

  function goTo(item) {
    appContext.navTo({ item });
  }

  return (
    <div className="TopBar">
      <div className="body">
        <div className="container d-flex justify-content-between align-items-center" style={{ height: "100%" }}>
          {/* Logo */}
          <div className="d-flex align-items-center" style={{ flexShrink: 1 }}>
            <img
              src={logo_icon}
              className="align-self-center d-none d-md-block"
              style={{ height: "80px", cursor: "pointer" }}
              onClick={() => goTo('home')}
            />
            <img
              src={logo_icon}
              className="align-self-center d-block d-md-none"
              style={{ height: "50px", cursor: "pointer" }}
              onClick={() => goTo('home')}
            />
          </div>

          {/* Desktop Menu */}
          <div className="d-none d-md-flex align-items-center gap-3">
            <div className={`mMenuItem text-secondary ${appContext.navItem === "home" ? "fw-bold" : "text-dark"}`} onClick={() => goTo("home")}>Home</div>
            <div className={`mMenuItem text-secondary ${appContext.navItem === "about_us" ? "fw-bold" : "text-dark"}`} onClick={() => goTo("about_us")}>About Us</div>
            <div className={`mMenuItem text-secondary ${appContext.navItem === "services" ? "fw-bold" : "text-dark"}`} onClick={() => goTo("services")}>Services</div>
            <button className="btn font-bold btn-secondary ms-2" style={{ fontSize: "14px" }} onClick={() => goTo("contact_us")}>CONTACT US</button>
          </div>

          {/* Mobile Menu Button */}
          <div className="d-block d-md-none">
            <MdMenu size={32} className="text-secondary" onClick={appContext.openSideBar} style={{ cursor: "pointer" }} />
          </div>
        </div>
      </div>
    </div>
  );
}
